import React, {Component} from 'react';

// Components
import {Card, Grid} from '@material-ui/core';
import Anchor from 'Components/common/Anchor';
import Tag from 'Components/common/Tag';
import BasicButton from 'Components/lto/common/BasicButton';
import util from 'Utils/commonUtil';
import {BT_TYPE} from 'Utils/constant';

// Actions
import {T} from 'Actions/translate';

// Icons
import {KeyboardArrowRight, PersonOutlineOutlined} from '@material-ui/icons';

class CustomerCard extends Component {
    chooseCustomer = () => {
        const {locked, fromB2bPlatform} = this.props;
        if (!locked && util.getPropertyExistsAndIsTrue(fromB2bPlatform)) {
            if (this.props.chooseCustomer) {
                this.props.chooseCustomer(this.props.customerDetails);
            }
        } else {
            return null;
        }
    };

    onlineOrderHandle = (e) => {
        if (this.props.onlineOrderHandle) {
            this.props.onlineOrderHandle(e, this.props.customerDetails);
        }
    };

    offlineOrderHandle = (e) => {
        if (this.props.offlineOrderHandle) {
            this.props.offlineOrderHandle(e, this.props.customerDetails);
        }
    };

    showActionHandle = () => {
        const {locked, fromB2bPlatform} = this.props;
        let actionRender = null;

        if (!locked && util.getPropertyExistsAndIsTrue(fromB2bPlatform)) {
            actionRender = (
                <Grid className="right-content-grid" item xs={1}>
                    <KeyboardArrowRight />
                </Grid>
            );
            return actionRender;
        } else if (locked && locked !== 2) {
            actionRender = (
                <Tag
                    className="locked-label"
                    value={T('billOverdue')}
                    theme="red"
                />
            );
            return actionRender;
        } else {
            actionRender = null;
            return actionRender;
        }
    };

    getOrderTypeClassName = () => {
        const {customerDetails} = this.props;

        if (
            customerDetails.btType &&
            customerDetails.btType === BT_TYPE.DEALER
        ) {
            return 'offline-btn dealer-btn';
        } else {
            return 'offline-btn';
        }
    };

    render() {
        const {locked, customerDetails, fromB2bPlatform} = this.props;
        return (
            <Card className="customer-card">
                <Anchor
                    className="link"
                    disabled={locked === 1}
                    onClickOfSingleTap={this.chooseCustomer}>
                    <Grid
                        className={
                            !locked || locked === 2
                                ? 'card-content purchaes-order-card-content'
                                : 'card-content locked purchaes-order-card-content'
                        }
                        testid="customer-card-content"
                        data-ship-to={customerDetails.shipToNo}
                        container
                        spacing={0}>
                        <Grid
                            className="left-content-grid"
                            item
                            xs={
                                util.getPropertyExistsAndIsTrue(fromB2bPlatform)
                                    ? 11
                                    : 12
                            }>
                            {!customerDetails.isDummy &&
                                !util.getPropertyExistsAndIsTrue(
                                    fromB2bPlatform,
                                ) && (
                                    <Grid
                                        className="tfs-customer customer-info-row"
                                        container
                                        spacing={0}>
                                        <Grid
                                            item
                                            className="tfs-customer-label first-column">
                                            <img
                                                src={
                                                    new URL(
                                                        'Images/gray_personal.svg',
                                                        import.meta.url,
                                                    ).href
                                                }
                                                alt=""
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            className="tfs-customer-value second-column">
                                            <label testid="customer-card-contact-name">
                                                {customerDetails.firstName
                                                    ? customerDetails.lastName +
                                                      customerDetails.firstName
                                                    : T('order_no_name')}
                                            </label>
                                            <span testid="customer-card-contact-email">
                                                {customerDetails.email}
                                            </span>
                                        </Grid>
                                    </Grid>
                                )}

                            <Grid
                                className="ship-to-name lto-ship-to-name customer-info-row"
                                container
                                spacing={0}>
                                <Grid
                                    item
                                    className="lto-ship-to-label first-column">
                                    <img
                                        src={
                                            new URL(
                                                'Images/gray_st.svg',
                                                import.meta.url,
                                            ).href
                                        }
                                        alt=""
                                    />
                                </Grid>
                                <Grid
                                    item
                                    testid="customer-card-ship-to-number"
                                    className="lto-ship-to-value second-column">
                                    {customerDetails.shipToNo}

                                    {customerDetails.btType &&
                                        customerDetails.btType ===
                                            BT_TYPE.DEALER && (
                                            <div
                                                className="dealer-flag"
                                                testid="customer-card-dealer-indicator">
                                                {T('Dealer')}
                                            </div>
                                        )}
                                </Grid>
                            </Grid>

                            <Grid
                                className="lto-subject customer-info-row"
                                container
                                spacing={0}
                                item
                                xs={12}>
                                <Grid
                                    item
                                    className={
                                        util.getPropertyExistsAndIsTrue(
                                            fromB2bPlatform,
                                        )
                                            ? 'lto-subject-label b2b-platform-first-column'
                                            : 'lto-subject-label first-column'
                                    }>
                                    {T('lto_purchase_order_subject')}
                                </Grid>
                                <Grid
                                    item
                                    className={
                                        util.getPropertyExistsAndIsTrue(
                                            fromB2bPlatform,
                                        )
                                            ? 'lto-subject-value b2b-platform-second-column'
                                            : 'lto-subject-value second-column'
                                    }>
                                    {customerDetails.subject}
                                </Grid>
                            </Grid>

                            {!util.getPropertyExistsAndIsTrue(
                                fromB2bPlatform,
                            ) ? (
                                <Grid
                                    className="lto-subject customer-info-row"
                                    container
                                    spacing={0}
                                    item
                                    xs={12}>
                                    <Grid
                                        item
                                        className="lto-subject-label first-column">
                                        {T('lto_purchase_order_address')}
                                    </Grid>
                                    <Grid
                                        item
                                        className="lto-subject-value second-column">
                                        {customerDetails
                                            ? util.formatAddress(
                                                  customerDetails.stCity,
                                                  customerDetails.stAddress,
                                                  customerDetails.stBuilding,
                                              )
                                            : ''}
                                    </Grid>
                                </Grid>
                            ) : null}
                        </Grid>

                        {this.showActionHandle()}
                    </Grid>

                    {!util.getPropertyExistsAndIsTrue(fromB2bPlatform) ? (
                        <Grid
                            className={
                                customerDetails.isDummy
                                    ? 'line-up-or-down line-down'
                                    : 'line-up-or-down'
                            }>
                            {!customerDetails.isDummy ? (
                                <BasicButton
                                    className={
                                        customerDetails.onlineOrderOnly
                                            ? 'online-btn purchase-order-btn'
                                            : 'online-btn'
                                    }
                                    type="primary"
                                    testid="online-order-btn"
                                    onClickOfSingleTap={this.onlineOrderHandle}
                                    // onTouchStart={this.phoneClick}
                                >
                                    <img
                                        src={
                                            new URL(
                                                'Images/online-confirm.svg',
                                                import.meta.url,
                                            ).href
                                        }
                                        alt=""
                                    />{' '}
                                    {T('lto_purchase_order_line_up')}
                                </BasicButton>
                            ) : null}
                            {!customerDetails.onlineOrderOnly ? (
                                <BasicButton
                                    className={this.getOrderTypeClassName()}
                                    type="primary"
                                    testid="offline-order-btn"
                                    onClickOfSingleTap={
                                        this.offlineOrderHandle
                                    }>
                                    <img
                                        src={
                                            new URL(
                                                'Images/offline-confirm.svg',
                                                import.meta.url,
                                            ).href
                                        }
                                        alt=""
                                    />{' '}
                                    {T('lto_purchase_order_line_down')}
                                </BasicButton>
                            ) : null}
                        </Grid>
                    ) : null}
                </Anchor>
            </Card>
        );
    }
}

export default CustomerCard;
